import { MbbErrorCodes } from "./kobiconstants";

export const handleApiError = (history, errorCode, errorMsg) => {

  if (errorCode === MbbErrorCodes.JOB_TYPE_AND_AGE_DONT_MATCH || 
      errorCode === MbbErrorCodes.TAX_ID_NOT_ALLOWED || 
      errorCode === MbbErrorCodes.MERSIS_ERROR || 
      errorCode === MbbErrorCodes.WLF_ERROR ) {

      // go to error page
      history.push({
        pathname: "/result/error",
        state: { ErrorMessage: errorMsg}
      })

    return true
  } 

  return false

}